<div class='sideBarContent content loading-spinner' *ngIf="isLoading"></div>
<div class="sideBarContent editModelDetailComponent content" *ngIf="!isLoading">
  <irb-editor-sidebar-banner 
  [accordian]="accordian" 
  [showUnsavedChangesWarning]="showUnsavedChangesWarning" 
  [isModified]="isModified"
  [isValid]="isValid"
  [hasPendingFunction]="hasPendingFunction"
  [slot]="slot"
  (save)="save()"
  (cancel)="cancel()">
    <span header class="ms-header" tooltip [tooltipTitle]="slideOutTitle" [tooltipRequiresTruncation]="true">
      {{slideOutTitle}}
    </span>
    <span buttonsInFront>
      <button class="btn-medium-primary" *ngIf="!showUnsavedChangesWarning" id="editorSideReBalanceButton" (click)="onCreateRebalance()"
              [disabled]="isModified || !isRebalanceBtnEnabled ? true : false"
              >Rebalance</button>
    </span>
    <span buttonsInEnd>
      <button class="btn-medium-secondary" style="position: relative" *ngIf="modelEventData.showCopyModel && isCopyModelEnabled && !showUnsavedChangesWarning"
              (click)="onCopyModel()"
              [disabled]="isModified || !isValid"
      >Create a copy
      </button>
      <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-medium-secondary btnWithArrow"
      >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
          <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
              <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=R_MARK','_blank')">Research</button>
          </mat-menu>
      </button>
  </span>
  </irb-editor-sidebar-banner>

    <div [style.height]="bodyHeight" #body class="irb-editors-edit-model body">
      <editor-model-prevnext *ngIf="eventPrevNextObject && modelEventData && modelEventData.showNextPrev" [eventPrevNextObject]="eventPrevNextObject"></editor-model-prevnext>
        <div class="block  status-pending-review-warning" *ngIf="(isSubscribeModel && autoRebalPaused && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag)">
            <div class="left" style="width: calc(100% - 50px);">
                 <p class="message">
                    <span>
                        Automated rebalancing has been paused because one or more component models were changed by the model provider. You can review the changes in the model’s Model History and resume automated rebalancing, leave it paused, or replace the component model.
                    </span>
                 </p>
            </div>
            <div class="clear"></div>
        </div>
      <div class="block editorDisplayBanner editor-subscribe-model-banner" style="padding-bottom:0px;">
        <div class="subscribe-model-banner-item model-name-width" style="min-width:245px;">
          <div class="subscribe-model-banner-title">Model Name
          </div>
          <div *ngIf="!showInLineeditFlag"
               class="subscribe-model-banner-value">{{ data.blendedSecurityModelName }}
               <a class="editModelDetailEditLink" id="editLinkModelName2"(click)="showInlineEdit()">
                   <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
               </a>
          </div>
          <irb-com-inlineedit *ngIf="showInLineeditFlag" [(tooltipMessage)]="tooltipMessage"
                              defaultTooltip="Please provide valid model name."
                              [(data)]="data.blendedSecurityModelName"
                              allowSpecialCharacters="true"
                              (save)="saveInlineEdit($event)" (close)="closeInlineEdit()"
                              maxlength="100"
                              (change)="onTextChange()"></irb-com-inlineedit>
        </div>
        <div class="subscribe-model-banner-item model-description-width" style="min-width:245px;">
          <div class="subscribe-model-banner-title">Model Description
          </div>
          <div *ngIf="!showInLineEditDescFlag"
               class="subscribe-model-banner-value">{{ data.blendedSecurityModelDescription }}
              <a class="editModelDetailEditLink" id="editLinkDescr2" (click)="showInlineDescEdit()">
                <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
              </a>
          </div>
          <irb-com-inlineedit *ngIf="showInLineEditDescFlag" [(tooltipMessage)]="tooltipDescMessage"
                              defaultTooltip="Please provide valid model description."
                              [(data)]="data.blendedSecurityModelDescription"
                              allowSpecialCharacters="true"
                              (save)="saveInlineDescEdit($event)" (close)="closeInlineDescEdit()"
                              maxlength="100"></irb-com-inlineedit>
        </div>

        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Type</div>
          <div class="subscribe-model-banner-value">Blended</div>
        </div>

        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Models</div>
          <div class="subscribe-model-banner-value">{{noOfModels}}</div>
        </div>

        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Securities</div>
          <div class="subscribe-model-banner-value">{{ data.noOfSecurities }}</div>
        </div>

        <div class="subscribe-model-banner-item"  *ngIf="!(pfCount===undefined)">
            <div class="subscribe-model-banner-title" style="padding-bottom:8px;">Portfolios</div>
            <a class="subscribe-model-banner-value" tooltip [tooltipTitle]="isModified ? 'The model has unsaved changes. You\'ll need to save the changes before navigating to the portfolios.': null"
               tooltipPosition="bottom"
               (click)="showPortfoliosByModel()">{{ pfCount || 0 }} {{(pfCount === 1) ? 'portfolio' : 'portfolios'}}</a>
        </div>

        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Vendor Shared</div>
          <div class="subscribe-model-banner-value">
            <p-checkbox name="isVendorShared" [(ngModel)]="data.isVendorShared"
                        [disabled]="data.isAPIEnabled" binary="true" (onChange)="onInputChange();"></p-checkbox>
          </div>
        </div>

        <div class="subscribe-model-banner-item medium-second-line-width" *ngIf="isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag">
            <div class="subscribe-model-banner-title">Allow Automated Rebalances</div>
            <div class="mat-slide-toggle-container">
                <mat-slide-toggle [checked]="autoRebalAllowed"
                [disabled]="true">
                </mat-slide-toggle>
            </div>
        </div>
      </div>


    <mat-accordion #accordian="matAccordion" [multi]="true">
      <mat-expansion-panel id="BLENDEDMODELHISTORY" [expanded]="blendedAllocationHistoryState"
                           (opened)="onOpenHistoryPanel();"
                           (closed)="onCloseHistoryPanel()">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Model History
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-security-model-history *ngIf="historyData" [data]="historyData"
                                      [createModifyData]="createModifyData"
                                      modelType="Blended" ></irb-security-model-history>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="MODALALLOCATIONS" [expanded]="blendedModalAllocationState"
                           (opened)="ies.updateExpansionState('MODALALLOCATIONS','opened');this.allocationPanelOpened = true"
                           (closed)="ies.updateExpansionState('MODALALLOCATIONS','closed');this.allocationPanelOpened = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Model Allocations <img *ngIf="(autoRebalPaused || autoRebalNotAllowed) && isSubscribeModel && !allocationPanelOpened  && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag"
              class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-bottom: 3px; margin-left:10px">
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="block  status-pending-review-warning" *ngIf="(autoRebalPaused) && isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag">
            <p class="message">
                <span>
                    One or more component models have been changed by the model provider. Select the model’s name to review its Model History and resume automated rebalancing.
                </span>
            </p>
            <ul class="dotted-list">
              <li *ngFor="let item of autoRebalPausedList" style="list-style-type: disc; margin-left: 20px;">
                <a href="#" (click)="openSecurityModel(item); $event.preventDefault();">{{ item.securityModelName }}</a>
              </li>
            </ul>
          </div>
          <div class="block  status-not-allowed" *ngIf="(autoRebalNotAllowed) && isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag">
            <p class="message">
                <span>
                    One or more component models does not allow automated rebalancing. To use automated rebalancing for blended models, all component models must be set to allow it.
                </span>
            </p>
            <ul class="dotted-list">
              <li *ngFor="let item of autoRebalNotAllowedList" style="list-style-type: disc; margin-left: 20px;">
                <a href="#" (click)="openSecurityModel(item); $event.preventDefault();">{{ item.securityModelName }}</a>
              </li>
            </ul>
          </div>
          <irb-blended-models-allocation *ngIf="data" [(data)]="data" [mmcModelIds]="mmcModelIds"
                                    (change)="onInputChange()"></irb-blended-models-allocation>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="BLSECURITYALLOCATIONS" [expanded]="blendedSecAllocationState"
                           (opened)="ies.updateExpansionState('BLSECURITYALLOCATIONS','opened')"
                           (closed)="ies.updateExpansionState('BLSECURITYALLOCATIONS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Security Allocations
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-blended-security-allocation *ngIf="data" [data]="data"></irb-blended-security-allocation>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="BLSECURITYALLOCATIONSCHART" [expanded]="blendedSecurityAllocationChartState"
                           (opened)="ies.updateExpansionState('BLSECURITYALLOCATIONSCHART','opened')"
                           (closed)="ies.updateExpansionState('BLSECURITYALLOCATIONSCHART','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Allocations Chart
            <span style="margin-left: auto" *ngIf="ENABLE_SEC_GRID_CHART">
              <button class="btn-slim-primary settings-right" style="margin-right: 10px;" (click)="$event.stopPropagation(); showAllocationCustomView = true;" [disabled]="showAllocationCustomView">Customize view</button>
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <ng-container *ngIf="ENABLE_SEC_GRID_CHART; else oldBlendedChartTemplate">
            <irb-security-allocations-chart *ngIf="data && !isUiTest" modelType="Blended"
                                            [(showCustomView)]="showAllocationCustomView"></irb-security-allocations-chart>
          </ng-container>
          <ng-template #oldBlendedChartTemplate>
            <irb-legacy-allocations-chart *ngIf="data"
                                          modelType="Blended"></irb-legacy-allocations-chart>
          </ng-template>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
